import classnames from "classnames";
import { inject, observer } from 'mobx-react';
import React from "react";
import { Info, Share, User } from "react-feather";
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardBody, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, Button } from "reactstrap";
import "../../assets/scss/pages/users.scss";
import * as ROUTES from '../../constants/routes';
import CustomerAccountTab from "./components/AccountTab";
import CustomerInfoTab from "./components/InfoTab";
import CustomerSocialTab from "./components/SocialTab";
import CustomerStore from "../../stores/customerStore";
import FormError from "../common/FormError";

interface ICustomerEditProps {
  customerStore: CustomerStore,
  history: any,
  match: any
}

interface ICustomerEditState {
  activeTab: String
}

@inject('customerStore')
@observer
class CustomerEdit extends React.Component<ICustomerEditProps, ICustomerEditState> {

  state = {
    activeTab: "1"
  }

  async componentDidMount() {
    const { match } = this.props;
    let { customerStore } = this.props;
    await customerStore.loadCustomer(match.params.id);
  }

  onChangeText = (name: string, value: string) => {
    this.props.customerStore.setAttribute(name, value);
  };

  onBooleanChange = (name: string, value: boolean) => {
    this.props.customerStore.setBooleanAttribute(name, value);
  };

  onSave = () => {
    let { customerStore } = this.props;
    customerStore.saveCustomer(this.props.history);
  }

  onSaveImage = (value: string) => {
    let { customerStore } = this.props;
    customerStore.saveImage(value);
  }

  toggleTab = (tab: string) => {
    this.setState({
      activeTab: tab
    })
  }

  render() {
    const { customer, errors } = this.props.customerStore;
    return (
      <Row>
        <Col sm="12">
          <Card>
            <CardHeader>
              <Row className="justify-content-end">
              <Col className="d-flex justify-content-end flex-wrap mt-2" sm="12">
                  <Button className="mr-1" color="primary" onClick={(e)=> this.onSave()}>
                    Save
                  </Button>
                  <Link to={customer.uid ? `/customer/view/${customer.uid}` : '/customer'}>
                    <Button 
                      className="mr-1" 
                      color="danger" 
                      outline>
                    Cancel
                  </Button>
                  </Link>
                </Col>
              </Row>
            </CardHeader>
            <CardBody className="pt-2">
              <CustomerAccountTab onSaveImage={this.onSaveImage}
                customer={customer}
                onChangeText={this.onChangeText}
                onBooleanChange={this.onBooleanChange}
                onSave={this.onSave}
                errors={errors} />
              <CustomerInfoTab customer={customer}
                onChangeText={this.onChangeText}
                onSave={this.onSave}
                errors={errors} />
              <CustomerSocialTab customer={customer} onChangeText={this.onChangeText} onSave={this.onSave} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    )
  }
}

export default CustomerEdit;
